import { licenseMapper } from '../../helpers/licenseMapper';

export const dmObjMapper = item => {
    return {
        objectId: item.identifier,
        identifier: item.identifier,
        type: 'DM',
        image_id: item.image_id,
        published: item.published,
        dimuId: item.dimu_code,
        source: 'digitaltmuseum',
        url: item.image_url,
        title: item.title,
        artifactType: item.artifact_type,
        image_count: item.picture_count,
        producer: item.producer,
        owner_name: item.owner_name,
        licenses: (item.licenses && licenseMapper(item.licenses[0])) || [],
        local: {
            credit: item.owner_name,
            description: item.description || item.titledesc
        },
        media: {
            width: null,
            height: null,
            ratio: item.image_ratio
        },
        settings: {
            size: 'small'
        }
    }
};
